import { toast } from 'vue-sonner'

export const faToast = toast
